import { Link } from "react-router-dom";
import { money, productImage, productThumb } from "../../lib/api";

// Compact 2-column card for phone product grids.
export function MobileProductCard({ product }) {
  const minPrice = product.tier_pricing?.[0]?.unit_price ?? product.base_price;
  return (
    <Link
      to={`/shop/product/${product.slug}`}
      className="bg-white border border-slate-200 active:border-kolt-orange flex flex-col overflow-hidden"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative aspect-square bg-slate-50 overflow-hidden">
        <img src={productThumb(product.image_url, 400)} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
        {product.is_featured && (
          <span className="absolute top-2 left-2 font-mono text-[8px] tracking-[0.2em] uppercase font-bold bg-kolt-orange text-white px-1.5 py-0.5">
            Featured
          </span>
        )}
      </div>
      <div className="p-3 flex flex-col flex-1">
        <h3 className="font-display font-bold text-[13px] text-kolt-slate-dark leading-snug line-clamp-2 mb-2 flex-1">{product.name}</h3>
        <div className="flex items-baseline justify-between gap-2">
          <div className="font-display font-black text-base text-kolt-slate-dark leading-none">
            {money(minPrice)}
            <span className="text-[10px] text-slate-500 font-semibold ml-0.5">/ unit</span>
          </div>
          <span className="font-mono text-[9px] tracking-[0.18em] uppercase font-bold text-kolt-orange">Configure</span>
        </div>
      </div>
    </Link>
  );
}
